/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_Point_MachinesInputs */

const en_directory_hubs_signals_ai_point_machines = /** @type {(inputs: Directory_Hubs_Signals_Ai_Point_MachinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents evaluate products the way a new engineer would: can I find it, learn it, run it, and confirm the result without asking a human?`)
};

const zh_directory_hubs_signals_ai_point_machines = /** @type {(inputs: Directory_Hubs_Signals_Ai_Point_MachinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 评估产品的方式像一位新工程师：我能否不找人类帮忙就找到它、学会它、运行它并确认结果？`)
};

/**
* | output |
* | --- |
* | "Agents evaluate products the way a new engineer would: can I find it, learn it, run it, and confirm the result without asking a human?" |
*
* @param {Directory_Hubs_Signals_Ai_Point_MachinesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_point_machines = /** @type {((inputs?: Directory_Hubs_Signals_Ai_Point_MachinesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_Point_MachinesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_point_machines(inputs)
	return zh_directory_hubs_signals_ai_point_machines(inputs)
});
export { directory_hubs_signals_ai_point_machines as "directory.hubs.signals.ai.point.machines" }